import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

function ProtectedRoute({ component: Component, path, ...rest }) {
  const allowedPaths = useSelector((state) => state.userReducer.allowedPaths);

  return (
    <Route
      {...rest}
      render={(props) =>
        allowedPaths.includes('/') ||
        allowedPaths.includes(path) ||
        allowedPaths.includes('/' + path.split('/')[1]) ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/unauthorized' }} />
        )
      }
    />
  );
}

export default ProtectedRoute;
